import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Colour from 'color';

const Container = styled.div`
  width: 100%;
  background-color: ${props => props.bgColor};
  height: 57px;
  border: 1px solid rgba(142, 163, 181, 0.3);
  border-bottom-style: hidden;

  ${props => (props.bgColor !== Colour('white').hex()) && `
    border: 1px solid ${props.bgColor};
  `};

  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;

  ${props => props.theme.isMobileOrTablet && `
    height: 51px;
  `};

  ${props => props.theme.isXLarge && `
    border-radius: 6px 6px 0 0;
  `};
`;

const LogoContainer = styled.div`
  background-color: ${props => props.bgColor};
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;

  height: 22px;
  width: 125px;
  margin-right: 28px;

  ${props => props.theme.isMobile && `
    margin-right: 20px;
  `};

  ${props => props.theme.isLarge && `
    height: 23px;
    width: 128px;
    margin-right: 24px;
  `};

  ${props => props.theme.isXLarge && `
    height: 24px;
    width: 135px;
  `};
`;

const Logo = styled.img`
  height: 100%;
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-image: linear-gradient(96deg, #fff 31%, #d4dfeb 99%);
`;

const white = Colour('white').hex();
export default function Branding(props) {
  if (!props.logo) {
    return null;
  }
  let c;
  try {
    c = Colour(props.color || white);
  } catch (err) {
    c = Colour(white);
  }
  const bgColor = c.hex();
  return (
    <>
      <Container bgColor={bgColor}>
        <LogoContainer bgColor={bgColor}>
          <Logo src={props.logo} />
        </LogoContainer>
      </Container>
      {bgColor === white && <Divider />}
    </>
  );
}

Branding.propTypes = {
  logo: PropTypes.string.isRequired,
  color: PropTypes.string,
};

Branding.defaultProps = {
  color: null,
};
